export let stationBaseTypes=[
    { id: "manage", label: "管理类" },
    { id: "technology", label: "技术类" },
    { id: "marketing", label: "营销类" },
    { id: "function", label: "职能类" }
];
let stationTypes = [
    { id: "all", label: "所有岗位" },
    ...stationBaseTypes,
];

export default  stationTypes;


// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/stationTypes.js